import {
	buildDailyBuckets,
	presetToRange,
	toApiDateRange,
	type DateRangePreset,
} from '@/pages/dashboard/utils/dateRangeUtils'
import moment from 'moment'
import {
	normalizePaymentStatus,
	SubscriptionPaymentStatusTypes,
	type AdminTransactionListResponse,
} from '@/services/transactionTypes'

export type { DateRangePreset }
export { presetToRange, toApiDateRange, buildDailyBuckets }

export function buildVolumeSeries(rows: AdminTransactionListResponse[], dateFrom: string, dateTo: string) {
	return buildDailyBuckets(rows, dateFrom, dateTo, () => 1)
}

export function buildRevenueSeries(rows: AdminTransactionListResponse[], dateFrom: string, dateTo: string) {
	return buildDailyBuckets(rows, dateFrom, dateTo, (row) =>
		normalizePaymentStatus(row.paymentStatus) === SubscriptionPaymentStatusTypes.Succeeded ? row.amount : 0
	)
}

/** Combined daily points for volume + revenue trend chart (datetime x-axis). */
export function buildVolumeRevenueTrendPoints(
	rows: AdminTransactionListResponse[],
	dateFrom: string,
	dateTo: string
) {
	const volume = buildVolumeSeries(rows, dateFrom, dateTo)
	const revenue = buildRevenueSeries(rows, dateFrom, dateTo)

	return volume.labels.map((label, i) => ({
		x: moment(dateFrom).startOf('day').add(i, 'days').valueOf(),
		label,
		volume: volume.buckets[i] ?? 0,
		revenue: revenue.buckets[i] ?? 0,
	}))
}

export function formatMoney(amount: number, currency: string) {
	try {
		return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency.toUpperCase() }).format(amount)
	} catch {
		return `${amount.toFixed(2)} ${currency.toUpperCase()}`
	}
}
